import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from '@client/components/inputs/button/Button';
import ReactLink from '@client/components/links/reactLink/ReactLink';
import Flex from '@client/components/flex/Flex';
import allerLogo from '@client/shared/images/landingPageAssets/aller-logo-black.svg';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './sparks.scss';

const Sparks = () => {
  return (
    <section className={styles.sparksSection}>
      <div className={styles.bgImage}>
        <Flex
          alignCenter
          justifyCenter
          className={classNames(
            styleHelper.landingPageSectionContent,
            styles.contentContainer
          )}
        >
          <BoxWithLink />
          <SparksCopyContent />
        </Flex>
      </div>
    </section>
  );
};

export default Sparks;

const BoxWithLink = () => {
  const { t } = useTranslation(['landing']);
  return (
    <Flex column alignCenter className={styles.boxWithLink}>
      <h3 className={classNames(styleHelper.landingH5, styleHelper.mgt8)}>
        {t('landing:sparks.box.title')}
      </h3>
      <p
        className={classNames(
          styleHelper.landingP2,
          styleHelper.mgt16,
          styles.copyParagraph
        )}
      >
        {t('landing:sparks.box.description')}
      </p>
      <ReactLink
        to={'/advertiser'}
        className={classNames(styleHelper.mgt56, styles.link)}
      >
        <Button
          className={classNames(styleHelper.btnContained, styles.button)}
          label={t('landing:sparks.box.buttonLabel')}
        />
      </ReactLink>
    </Flex>
  );
};

const SparksCopyContent = () => {
  const { t } = useTranslation(['landing']);
  return (
    <Flex flexNr={1} column className={styles.copyContent}>
      <img src={allerLogo} className={styles.allerMediaLogo} />
      <h2 className={classNames(styleHelper.landingH3, styleHelper.mgt16)}>
        {t('landing:sparks.title')}
      </h2>
      <p className={classNames(styleHelper.landingP2, styleHelper.mgt16)}>
        {t('landing:sparks.description')}
      </p>
    </Flex>
  );
};
